
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ChartActions } from '@/store/actions/charts';
import TimelineChart from '@/components/DataTab/Charts/ChartComponents/TimelineSummaryCharts/TimelineChart.vue';
import {
  ChartReturnType,
  ScenarioNameType,
  TimelineFormattedType,
} from '@/types';
import ChartHeading from '@/components/DataTab/Charts/ChartComponents/ChartHeading.vue';

@Component({
  components: {
    ChartHeading,
    TimelineChart,
  },
})
export default class TimelineChartWithTitle extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showTooltip!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideDescription!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideUnit!: boolean;

  mounted() {
    this.$store.dispatch(ChartActions.CHART_REQUEST, {
      chartId: this.selectedChartId,
      basinId: this.selectedArea.id,
    });
  }

  get chartStatus() {
    return this.$store.getters.chartStatus;
  }

  get description() {
    return this.$t(`data.chartTables.${this.selectedChartId}.description`);
  }

  get timelineData(): TimelineFormattedType[] {
    let formattedData: TimelineFormattedType[] = [];
    this.$store.getters.data.forEach((item: ChartReturnType) => {
      if (item.sum && item.year) {
        formattedData.push({
          value: item.sum,
          date: item.year,
          scenario: item.scenario as ScenarioNameType,
        });
      }
    });
    return formattedData;
  }

  get selectedArea() {
    return this.$store.getters.selectedArea;
  }

  get selectedChartId(): number {
    return this.$store.getters.selectedChart;
  }

  get scenarioList(): ScenarioNameType[] {
    return this.$store.getters.selectedScenarioList;
  }
}
